import { FormElems } from '../../components/';
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import 'react-quill/dist/quill.snow.css';
import 'rc-tooltip/assets/bootstrap_white.css';
import closeImgIcon from 'static/images/close.svg';
import profile from 'static/images/profile.png';
import paymentInfo from '../../static/images/paymentInfo.png';
import './PaymentPageTab.scss';

const PreviewModal = props => {
    const { fields, amountType, amount, minAmount, maxAmount, onClose, formData = {}, desc, auth } = props;

    return (
        <div className="modal-overlay preview">
            <div className="overlay-black">
                <div className="modal-info">
                    <div className="modal-head">
                        <h2>Preview</h2>
                        <img src={closeImgIcon} alt="Close" onClick={onClose} />
                    </div>
                    <div className="modal-content">
                        <div className="merchant-deatils">
                            <img
                                className="merchant-logo"
                                src={profile}
                                alt="Merchant phto"
                            />
                            <h2>{auth?.userDetails?.entityName}</h2>
                        </div>
                        <div className="merchant-purpose-desc">
                            <div className="purpose">
                                {formData.values?.purpose}
                            </div>
                            <div className="desc">
                                <div
                                    dangerouslySetInnerHTML={{ __html: desc }}
                                />
                            </div>
                        </div>
                        <div className="pay-info">
                            <img src={paymentInfo} alt="paymentInfo" />
                            <div className="purpose">Payment Information</div>
                        </div>
                        <div className="amount">
                            <div className='amount-field'>
                                <h2>Amount</h2>
                                <span className="required-asterisk">*</span>
                                {amountType === "VARIABLE" && ` (Min: ₹${minAmount} - Max: ₹${maxAmount})`}
                            </div>
                            {amountType === "VARIABLE" ? (
                            <>
                                <Field
                                    className="amount-field"
                                    type="text"
                                    name=''
                                    component={FormElems.Input}
                                    disabled={true}
                                    placeholder={'Please enter amount'}
                                />
                            </>
                        ) : (
                            <Field
                                className="amount-field"
                                name="amount"
                                type="text"
                                component={FormElems.Input}
                                data={formData.values?.amount}
                                disabled={true}
                                placeholder={'Please enter amount'}
                            />
                        )}
                        </div>
                        <div className="dotted-line" />
                        <div className="fieldDetails">
                            {fields
                                .filter(
                                    field =>
                                        field.name && field.name?.trim() !== ''
                                )
                                .map((field, index) => (
                                    <div
                                        key={field.id}
                                        className="fieldChoosen"
                                    >
                                        <div className="fieldName">
                                            {field.name
                                                ?.split(" ")
                                                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter of each word
                                                .join(" ")}

                                            {field.validators ===
                                                'required' && (
                                                    <span className="required-asterisk">
                                                        *
                                                    </span>
                                                )}
                                        </div>
                                        <Field
                                            className="amount"
                                            name={`fieldChoosen-${index}`}
                                            type="text"
                                            component={FormElems.Input}
                                            disabled={true}
                                            placeholder={`Please enter ${field.name
                                                ?.charAt(0)
                                                .toUpperCase() +
                                                field.name
                                                    ?.slice(1)
                                                    .toLowerCase()}`}
                                        />
                                    </div>
                                ))}
                        </div>
                        <div className="payNow">
                            <FormElems.Button
                                id="next-btn"
                                buttonType="primary"
                                text={'Pay Now'}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


PreviewModal.propTypes = {
    fields: PropTypes.array.isRequired,
    onClose: PropTypes.func.isRequired,
    formData: PropTypes.object,
    desc: PropTypes.string,
    auth: PropTypes.object,
};
export default PreviewModal;